/* eslint-disable import/no-cycle */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React from 'react';
import dayjs from 'dayjs';
import moment from 'moment';
import Cookies from 'universal-cookie';
import shajs from 'sha.js';
import {
  INVALID_NAMES,
  ONLY_LETTERS_REGEX,
  BOOKING_TYPES,
  BOOKING_STATUS_OFFERED,
  ROUTE_TYPES,
  UK_AIR_NUMBER,
  USA_AIR_NUMBER,
  AUS_AIR_NUMBER,
  BAZIL_MARKET,
  COOKIE_KEYS,
  INVALID_SAILING,
} from './constants';
import theme from '../theme/booking-theme';
import { ReactComponent as WarningIcon } from '../assets/svg/warningIcon.svg';
import { ReactComponent as CheckIcon } from '../assets/svg/checkmark_white.svg';
import defaultNotifications from '../pages/index.defaults';
import {
  SHOW_EDIT_GUEST_INFO_CTA,
  VIEW_EDIT_GUEST_INFO_CTA,
  ENABLE_AFFIRM_PAYMENT,
} from './ld-user';
import { trackSucessUpdateField } from './tracking/editGuestInfoTracking';

const WWW_PREFIX = '';
const cookies = new Cookies({ path: '/' });
export const formatDate = (date, localizedDayjs) => {
  return localizedDayjs(date).format('YYYY-MM-DD');
};

export const formatTime = (currTime) => {
  return moment(currTime, 'HH:mm').format('h:mm A');
};

export const capitalizeText = (text) =>
  text
    .toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');

export const isGuestInfoComplete = (props) => {
  const dataComplete = props.guests.map((guest, i) => {
    return (
      (props.error && !props.errors.guests && !props.errors.guests[i]) ||
      (!INVALID_NAMES.includes(guest.firstName) && !INVALID_NAMES.includes(guest.lastName))
    );
  });
  return dataComplete.every((val) => {
    return val;
  });
};

export const getDurationLabel = (totalDurationMins) => {
  const hours = Math.floor(totalDurationMins / 60);
  const minutes = totalDurationMins % 60;
  const hoursLabel = hours === 0 ? '' : `${hours}h`;
  const minutesLabel = minutes === 0 ? '' : `${minutes}m`;

  return `${hoursLabel} ${minutesLabel}`;
};

export const getStopsCodes = (stops) => {
  // return flight scales airport codes form an array of flightsegments
  const stopsCodes = [];
  stops.forEach((stop, index) => {
    if (index > 0) {
      stopsCodes.push(stop.departure.airport.code);
    }
  });
  return stopsCodes;
};

export const layover = (numberOfStops, renderContent) => {
  if (numberOfStops === 0) {
    return renderContent('flightSummaryNonstopLabel', 'Nonstop');
  }
  if (numberOfStops === 1)
    return `${numberOfStops} ${renderContent('flightSummaryStopInLabel', 'stop in ')} `;
  return `${numberOfStops} ${renderContent('flightSummaryStopsInLabel', 'stops in ')} `;
};

export const lastDestination = (segments) => {
  let finalAirport;
  segments.forEach((segment, index) => {
    if (index === segments.length - 1) {
      finalAirport = segment.arrival.airport.code;
    }
  });
  return finalAirport;
};
export const getPassengers = (flightProfile, confirmationNumbers) => {
  // return guests who have a flight booked in a reservation
  const flightGuests = [];
  const guestWithSameFlight = flightProfile.guests.filter((guest) => {
    if (guest.flightGuest.guestFlights) {
      return guest.flightGuest.guestFlights[0].confirmationNumbers.every((confNum) =>
        confirmationNumbers.includes(confNum),
      );
    }
    return null;
  });

  guestWithSameFlight.forEach((guest) => {
    flightGuests.push(
      `${capitalizeText(guest.flightGuest.firstName)} ${capitalizeText(
        guest.flightGuest.lastName,
      )}`,
    );
  });
  return flightGuests;
};
const isWwwCookieExists = (cookieDomains) => {
  return cookieDomains.length === 0
    ? false
    : cookieDomains.filter((x) => x.includes(WWW_PREFIX, 0)).length === 0;
};

const addMissingWwwCookieDomain = (cookieDomains, fullhostname) => {
  const isWwwCookieDomainMissing = isWwwCookieExists(cookieDomains);
  if (isWwwCookieDomainMissing) {
    cookieDomains.push(`${WWW_PREFIX}${fullhostname}`);
  }
  return cookieDomains;
};

const getAllCookieDomains = () => {
  const fullhostname = window.location.hostname;
  const arrFullHostNames = fullhostname.split('.').reduce(
    (acc, part, idx, arr) => {
      if (idx > 0 && idx < arr.length - 1) {
        const value = isWwwCookieExists(acc)
          ? arr.slice(idx).join('.')
          : `.${arr.slice(idx).join('.')}`;
        acc.push(value);
      }
      return acc;
    },
    [fullhostname],
  );
  return addMissingWwwCookieDomain(arrFullHostNames, fullhostname);
};

const removeCookie = (key) => {
  const cookieDomains = getAllCookieDomains();
  cookieDomains.forEach((domain) => {
    document.cookie = `${key}=;expires=1970-09-25T22:27:16.000Z;max-age=0;path=/;domain=${domain};`;
  });
};

const deleteCookie = (cookie) => {
  cookies.remove(cookie, { path: '/' });
};

export const cleanCookie = (cookie) => {
  return cookies.remove(cookie, { path: '/' });
};

export const signOffProfile = (client) => {
  sessionStorage.clear();
  client.clearStore();
  removeCookie(COOKIE_KEYS.ACCESS_TOKEN);
  removeCookie(COOKIE_KEYS.LOYALTY_DATA);
  deleteCookie(COOKIE_KEYS.ACCESS_TOKEN);
  deleteCookie(COOKIE_KEYS.LOYALTY_DATA);
};

const setFlightType = (flights) => {
  if (flights.length === 1)
    return {
      flightType: ROUTE_TYPES.ONE_WAY_TRIP,
      departure: flights[0].flightSegments[0].departure?.airport?.code,
      arrival:
        flights[0].flightSegments[flights[0].flightSegments.length - 1].arrival?.airport?.code,
    };
  if (
    flights[0]?.flightSegments[flights[0].flightSegments.length - 1]?.arrival?.airport?.code ===
    flights[1]?.flightSegments[0]?.departure?.airport?.code
  )
    return {
      flightType: ROUTE_TYPES.ROUND_TRIP,
      departure: flights[0]?.flightSegments[0].departure?.airport?.code,
      arrival: flights[1]?.flightSegments[0].departure?.airport?.code,
    };
  return {
    flightType: ROUTE_TYPES.MULTI_CITY,
    departure: flights[0]?.flightSegments[0]?.departure?.airport?.code,
    arrival:
      flights[0]?.flightSegments[flights[0].flightSegments.length - 1]?.arrival?.airport?.code,
    multyCity: flights[1]?.flightSegments[0]?.departure.airport.code,
  };
};
const getFlightsPerLocatorArray = (locatorArraySingle, getGuests) => {
  const flightsPerLocator = locatorArraySingle.map((locator) => {
    // eslint-disable-next-line
    for (const guest of getGuests) {
      const flights = guest?.flightGuest?.guestFlights;
      // eslint-disable-next-line
      if (!flights) continue;
      const filterFlight =
        JSON.stringify(guest?.flightGuest?.gdsLocators) === JSON.stringify(locator);
      if (filterFlight) {
        const confirmationNumberData = flights.map((flight) =>
          flight.confirmationNumbers.join('/'),
        );
        const confirmationNumber = [...new Set(confirmationNumberData)];
        return {
          gdsLocator: locator,
          flights,
          type: setFlightType(flights),
          confirmationNumber,
        };
      }
    }
    return null;
  });
  return flightsPerLocator;
};

const getUniqueLocator = (getGuests) => {
  const uniqueGdsLocatorArrays = [
    ...new Set(getGuests?.map((item) => JSON.stringify(item.flightGuest.gdsLocators))),
  ].map((str) => JSON.parse(str));
  return uniqueGdsLocatorArrays;
};

const getCardInfo = (gdsLocatorsArray, getGuests, flightsPerLocator) => {
  const cardInfo = gdsLocatorsArray.map((locator) => {
    const cardData = {
      gdsLocators: locator,
      names: [],
      passengerCount: 0,
      allowCancellation: true,
      allowReshop: true,
      transfers: [],
    };
    getGuests.forEach((item) => {
      const { gdsLocators } = item.flightGuest;
      if (JSON.stringify(gdsLocators) === JSON.stringify(locator)) {
        cardData.names.push(`${item.flightGuest.firstName} ${item.flightGuest.lastName}`);
        cardData.allowCancellation =
          cardData.allowCancellation && item.flightGuest.allowCancellation;
        cardData.allowReshop = item.flightGuest.allowReshop;
        cardData.transfers = item.flightGuest.transfers;
      }
    });
    return cardData;
  });

  return cardInfo.map((gsdLocatorData) => {
    return {
      gdsLocator: gsdLocatorData.gdsLocators,
      gdsLocatorString: gsdLocatorData.gdsLocators.join('-'),
      names: [...gsdLocatorData.names].join(', '),
      passengerCount: [...gsdLocatorData.names].length,
      flightsPerLocator: flightsPerLocator.find(
        (flight) =>
          JSON.stringify(flight.gdsLocator) === JSON.stringify(gsdLocatorData.gdsLocators),
      ),
      allowCancellation: gsdLocatorData.allowCancellation,
      allowReshop: gsdLocatorData.allowReshop,
      transfers: gsdLocatorData.transfers,
    };
  });
};

export const groupAirGuest = (flightProfile) => {
  const getGuests = flightProfile?.guests.filter(
    (guest) => guest.flightGuest.guestFlights !== null && guest,
  );
  const locatorArraySingle = getUniqueLocator(getGuests);
  const flightsPerLocatorArray = getFlightsPerLocatorArray(locatorArraySingle, getGuests);
  const cardInfo = getCardInfo(locatorArraySingle, getGuests, flightsPerLocatorArray);
  return cardInfo;
};

export const layoverDays = (dates) => {
  const departure = dayjs(dates.departure);
  const arrival = dayjs(dates.arrival);
  const diffDays = arrival.diff(departure, 'day');
  return diffDays > 0 ? `+${diffDays}` : '';
};

export const getAirlines = (flightSegments) => {
  const allAirlines = flightSegments.map((segment) => segment.operatingAirline.name);
  const uniqueAirlines = new Set(allAirlines);
  return [...uniqueAirlines];
};

// display formated ship position
// eslint-disable-next-line consistent-return
export const setPosition = (position) => {
  if (position === 'AF') {
    return 'Aft-Ship';
  }
  if (position === 'MS') {
    return 'Mid-Ship';
  }
  if (position === 'FW') {
    return 'Fwd-Ship';
  }
};

export const getGraphQLError = (err) => {
  const error = err && Array.isArray(err.graphQLErrors) && err.graphQLErrors[0];
  if (error?.message.includes('No valid sailings available')) {
    return defaultNotifications[INVALID_SAILING];
  }
  return (
    defaultNotifications[error?.extensions?.code] || defaultNotifications.INTERNAL_SERVER_ERROR
  );
};

export const setSessionStorageItem = (key, data) => {
  sessionStorage.setItem(key, JSON.stringify(data));
};

export const getUrlData = (key) => {
  const url = new URL(window.location);
  const params = new URLSearchParams(url.search);
  if (!key) {
    return params;
  }

  if (key === 'token') {
    const tokenMatch = url.search.match(new RegExp(`[?&]${key}=([^&]*)`));
    return tokenMatch ? tokenMatch[1] : null;
  }

  return params?.get(key);
};

export const getCookies = (key) => cookies.get(key);

const getRootSubDomain = () => {
  const locOrigin = window.location.hostname;
  let locOriginMatch = locOrigin.match(/.*(\.[^.]+\.[^.]+\.com\.[^.]+)$/);
  if (locOriginMatch == null) {
    locOriginMatch = locOrigin.match(/.*(\.[^.]+\.com\.[^.]+)$/);
  }
  if (locOriginMatch == null) {
    locOriginMatch = locOrigin.match(/.*(\.[^.]+\.[^.]+\.[^.]+)$/);
  }
  if (locOriginMatch == null) {
    locOriginMatch = locOrigin.match(/.*(\.[^.]+\.[^.]+)$/);
  }

  if (locOriginMatch != null) {
    return locOriginMatch[1];
  }
  return locOrigin;
};

export const createCookie = ({ name, value, time = null }) => {
  const domain = getRootSubDomain();
  const options = { path: '/', domain, secure: true };
  if (time !== null) {
    options.expires = time;
  }
  cookies.set(name, value, options);
};

export const getAirPhoneNumber = (booking) => {
  const valueMapMarket = {
    GBR: UK_AIR_NUMBER,
    IRL: UK_AIR_NUMBER,
    NZL: AUS_AIR_NUMBER,
    AUS: AUS_AIR_NUMBER,
  };
  return valueMapMarket[booking?.country?.code?.toUpperCase()] || USA_AIR_NUMBER;
};
export function isPaymentDisable(booking) {
  return (
    booking?.country?.code === BAZIL_MARKET ||
    booking?.type === BOOKING_TYPES.TA ||
    booking?.type === BOOKING_TYPES.GRP
  );
}

export const getSessionStorageItem = (key, shouldParseObject = true) => {
  try {
    let sessionStorageString = sessionStorage.getItem(key);
    if (sessionStorageString === 'null') {
      sessionStorageString = null;
    }
    return shouldParseObject ? JSON.parse(sessionStorageString) : sessionStorageString;
  } catch {
    return null;
  }
};

export const removeSessionStorageItem = (key) => {
  sessionStorage.removeItem(key);
};

export const findErrorCode = (error, code) => {
  if (typeof code === 'string') {
    return error.graphQLErrors.find(({ extensions }) => extensions.code === code);
  }
  return error.graphQLErrors.find(({ extensions }) => code.includes(extensions.code));
};

export const onlyLetters = (letter) => {
  return letter.split('').map((char) => {
    return ONLY_LETTERS_REGEX.test(char) ? ONLY_LETTERS_REGEX : null;
  });
};

export const notificationColor = (notificationType) => {
  if (notificationType === 'error') return theme.palette.error.main;
  if (notificationType === 'warning') return theme.palette.error.warning;
  return theme.palette.green;
};

export const notificationIcon = (notificationType) => {
  if (notificationType === 'error') return <WarningIcon />;
  return <CheckIcon />;
};

export const getOnlyGCPaymentAmount = (paymentInfo) => {
  const payments = paymentInfo?.variables?.makePaymentInput;
  const GiftCardAmount = payments
    ?.map((payment) => {
      if (payment.paymentMethod === 'GC') {
        return payment.amount;
      }
      return 0;
    })
    .reduce((prev, curr) => prev + (curr || 0), 0);
  return GiftCardAmount;
};

export const getCreditCardType = (paymentInfo) => {
  const payments = paymentInfo?.variables?.makePaymentInput;
  return payments?.map((payment) => {
    if (payment.paymentMethod === 'CC') {
      return payment.cardType;
    }
  });
};

export const showAffirm = (currency, balanceDue, ldFlags) => {
  const isAffirmPaymentEnable = ldFlags?.[ENABLE_AFFIRM_PAYMENT];
  return isAffirmPaymentEnable && currency === 'USD' && balanceDue >= 50;
};

export const importAffirmScript = (REACT_APP_API_KEY_AFFIRM, REACT_APP_AFFIRM_SCRIPT) => {
  /* eslint-disable */
  var _affirm_config = {
    public_api_key: REACT_APP_API_KEY_AFFIRM,
    script: REACT_APP_AFFIRM_SCRIPT,
  };
  try {
    (function (m, g, n, d, a, e, h, c) {
      const b = m[n] || {},
        k = document.createElement(e),
        p = document.getElementsByTagName(e)[0],
        l = function (a, b, c) {
          return function () {
            a[b]._.push([c, arguments]);
          };
        };
      b[d] = l(b, d, "set");
      const f = b[d];
      b[a] = {};
      b[a]._ = [];
      f._ = [];
      b._ = [];
      b[a][h] = l(b, a, h);
      b[c] = function () {
        b._.push([h, arguments]);
      };
      a = 0;
      for (
        c =
          "set add save post open empty reset on off trigger ready setProduct".split(
            " ",
          );
        a < c.length;
        a++
      )
        f[c[a]] = l(b, d, c[a]);
      a = 0;
      for (c = ["get", "token", "url", "items"]; a < c.length; a++)
        f[c[a]] = function () {};
      k.async = !0;
      k.src = g[e];
      p?.parentNode?.insertBefore(k, p);
      delete g[e];
      f(g);
      m[n] = b;
    })(
      window,
      _affirm_config,
      "affirm",
      "checkout",
      "ui",
      "script",
      "ready",
      "jsReady",
    );
  } catch (e) {
    console.log(e);
  }
  /* eslint-enable */
};

// Check when a value change on GuestInfo inputs
export const checkFieldUpdated = (
  currentBookingInfo,
  fieldName,
  fieldValue,
  index,
  setFieldUpdated,
  updatedFieldsState,
) => {
  const field = fieldName.split('.').pop();
  const arrayOfEditedFields = updatedFieldsState.updatedFields;
  const fieldExist = arrayOfEditedFields.find((item) => item.field === field);
  if (!fieldExist) {
    arrayOfEditedFields.push({ field, fieldValue, index: Number(index) });
  }
  if (fieldExist) {
    fieldExist.fieldValue = fieldValue;
  }
  updatedFieldsState.setUpdatedFields(arrayOfEditedFields);
  let atLeastOneFieldIsEdited = false;
  arrayOfEditedFields.forEach((fieldEdited) => {
    const previousValue = currentBookingInfo?.guests[fieldEdited.index][fieldEdited.field];
    const previousValueLowerCase = previousValue ? previousValue.toLowerCase() : previousValue;
    const newValueLowerCase = fieldEdited.fieldValue.toLowerCase();
    if (newValueLowerCase !== previousValueLowerCase && newValueLowerCase !== '') {
      atLeastOneFieldIsEdited = true;
    }
  });
  setFieldUpdated(atLeastOneFieldIsEdited);
};

// get as parameter two arrays of objects: previous values on ESL and current values to submit
export const checkFieldsUpdated = (previousValues, currentValues) => {
  // Transform all object values to uppercase
  previousValues.forEach((guest, index) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const field in guest) {
      if (typeof guest[field] === 'string') {
        // eslint-disable-next-line no-param-reassign
        guest[field] = guest[field].toUpperCase();
      }
    }
    // eslint-disable-next-line no-restricted-syntax
    for (const field in currentValues[index]) {
      if (typeof currentValues[index][field] === 'string') {
        // eslint-disable-next-line no-param-reassign
        currentValues[index][field] = currentValues[index][field].toUpperCase();
      }
    }
    // check previousValues with currentValues and send track fn if some field was updated
    // eslint-disable-next-line no-restricted-syntax
    for (const field in guest) {
      if (guest[field] !== currentValues[index][field]) {
        trackSucessUpdateField(field);
      }
    }
  });
};

export const getGuestInfoFlags = (bookingData, ldFlags) => {
  if (bookingData && ldFlags) {
    const guestInfoCtaFlag = ldFlags[SHOW_EDIT_GUEST_INFO_CTA];
    const viewGuestInfoCtaFlag = ldFlags[VIEW_EDIT_GUEST_INFO_CTA];
    const bookingType = bookingData?.type;
    const allowedBookingTypes = guestInfoCtaFlag?.allowedBookingTypes;
    const allowedViewBookingTypes = viewGuestInfoCtaFlag?.allowedBookingTypes;
    const showEditGuestInformationCta =
      allowedBookingTypes.includes(bookingType) || allowedBookingTypes[0] === '*';
    const showViewGuestInformationCta =
      allowedViewBookingTypes.includes(bookingType) || allowedViewBookingTypes[0] === '*';
    return {
      bookingType,
      showEditGuestInformationCta,
      showViewGuestInformationCta,
    };
  }
  return null;
};

export const disableEditGuestInformation = (bookingType, editFlag, viewFlag, isFlight, status) => {
  return (
    bookingType === BOOKING_TYPES.TA ||
    bookingType === BOOKING_TYPES.GRP ||
    (isFlight && viewFlag) ||
    !(!isFlight && editFlag) ||
    status === BOOKING_STATUS_OFFERED
  );
};

export function sha256(stringToBeHashed, hash) {
  return shajs('sha256').update(stringToBeHashed).digest(hash);
}

export const isValidTaxIdNumber = (cpf) => {
  if (!cpf) return false;
  // eslint-disable-next-line no-param-reassign
  cpf = cpf.replace(/[^\d]/g, ''); // Remove any non-digit characters

  const isSequence = (str) => str.split('').every((char) => char === str[0]);
  const calculateDigit = (str, limit) =>
    // eslint-disable-next-line radix
    (11 - (str.split('').reduce((sum, char, i) => sum + parseInt(char) * (limit - i), 0) % 11)) %
    10;

  if (cpf.length !== 11 || isSequence(cpf)) {
    return false;
  }

  const firstDigit = calculateDigit(cpf.slice(0, 9), 10);
  // eslint-disable-next-line radix
  if (parseInt(cpf.charAt(9)) !== firstDigit) {
    return false;
  }

  const secondDigit = calculateDigit(cpf.slice(0, 10), 11);
  // eslint-disable-next-line radix
  if (parseInt(cpf.charAt(10)) !== secondDigit) {
    return false;
  }

  return true;
};

export function allPropertiesDefined(obj) {
  return Object.values(obj).every((value) => value !== undefined);
}

export function isObjectNotEmpty(object) {
  if (object === null || object === undefined) {
    return false;
  }
  return Object.keys(object).length > 0;
}

export const generateRelativeUrl = (endpoint) => {
  const { origin } = window.location;
  if (origin?.includes('localhost')) {
    return endpoint;
  }
  return `${origin}${endpoint}`;
};

export const isAGuestWithoutFlight = (flightProfile) => {
  const guestsWithFlight = flightProfile?.guests?.filter(
    ({ flightGuest }) => flightGuest.guestFlights !== null,
  );
  return flightProfile?.guests?.length > guestsWithFlight?.length;
};

/**
 * Detects whether a string is percent-encoded (via encodeURIComponent).
 * @param {string} str
 * @returns {boolean}
 */
export function isEncodedURIComponent(str) {
  // Quick check: look for "%XX" where X is a hex digit
  if (!/%[0-9A-Fa-f]{2}/.test(str)) return false;

  try {
    // Decode and then re-encode
    const decoded = decodeURIComponent(str);
    const reencoded = encodeURIComponent(decoded);

    // If re-encoding yields exactly the same string,
    // it was very likely encoded to begin with.
    return reencoded === str;
  } catch (e) {
    // decodeURIComponent will throw if str contains invalid % sequences,
    // so it wasn’t properly encoded.
    return false;
  }
}

/**
 * Safely decodes only if needed.
 */
export function safeDecode(str) {
  if (!str) return '';
  return isEncodedURIComponent(str) ? decodeURIComponent(str) : str;
}

/**
 * Safely encodes only if needed.
 */
export function safeEncode(str) {
  if (!str) return '';
  return isEncodedURIComponent(str) ? str : encodeURIComponent(str);
}
